export const decorateBytes = (bytes: number, decimals?: number) => {
  if (!bytes || bytes === 0) return '0 Byte';
  const k = 1000; // or 1024 for binary
  const dm = decimals || 1;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
